// Generated by scripts/import-project-images.py. Originals remain untouched.
import asset0 from "../img/projectImages/69caeb4a032fd013a31c.webp";
import asset1 from "../img/projectImages/db1fbb6b6ee577fb5127.webp";
import asset2 from "../img/projectImages/9849912e8bedd57d6287.webp";
import asset3 from "../img/projectImages/61a23e8ed0ea67157a92.webp";
import asset4 from "../img/projectImages/3c1181cfe29d23f69a7a.webp";
import asset5 from "../img/projectImages/1ebba6e052bb0c69ab05.webp";
import asset6 from "../img/projectImages/657c53fd10183c2b6f92.webp";
import asset7 from "../img/projectImages/19a8ae4ef45962aec4db.webp";
import asset8 from "../img/projectImages/6547c3bba50d33c04fbf.webp";
import asset9 from "../img/projectImages/0ee0c238be6c517a726c.webp";
import asset10 from "../img/projectImages/1e3a2d6b2a6c09f30d53.webp";
import asset11 from "../img/projectImages/ef2dd213771493b3b76b.webp";
import asset12 from "../img/projectImages/267eab11917772fc479a.webp";
import asset13 from "../img/projectImages/b62eb15ff7d22a68655d.webp";
import asset14 from "../img/projectImages/9fe03f6230c02701fc8d.webp";
import asset15 from "../img/projectImages/0516a4ddce0bfa83c4dd.webp";
import asset16 from "../img/projectImages/9d52eb95a3793b7bcc95.webp";
import asset17 from "../img/projectImages/ff2acc9b3b2c2af410d7.webp";
import asset18 from "../img/projectImages/ee48f477cfb2ecb0fb2f.webp";
import asset19 from "../img/projectImages/72d72ed9356aedc32d6b.webp";
import asset20 from "../img/projectImages/8a57fb0c7085274f4786.webp";
import asset21 from "../img/projectImages/e278d2c5d3132a0485dd.webp";
import asset22 from "../img/projectImages/be9d4026021bb8554e42.webp";
import asset23 from "../img/projectImages/a26ea3f736d33b854e58.webp";
import asset24 from "../img/projectImages/9f4d4940ba9da418e6b1.webp";
import asset25 from "../img/projectImages/d3aeee2eb64c7fdbf0a2.webp";
import asset26 from "../img/projectImages/faf358a1e9f00634f8d7.webp";
import asset27 from "../img/projectImages/ebde5dc7f6c72e1330da.webp";
import asset28 from "../img/projectImages/8a40200633ddc09c2cba.webp";
import asset29 from "../img/projectImages/22a12dd308b8a997ee55.webp";
import asset30 from "../img/projectImages/c0cba516ccf215d772b7.webp";
import asset31 from "../img/projectImages/a77ee5b38cd991a6ac2c.webp";
import asset32 from "../img/projectImages/e033a3429dc58cac73e0.webp";
import asset33 from "../img/projectImages/3a43e5c4858432aa0065.webp";
import asset34 from "../img/projectImages/68c273278f99aca9d5e0.webp";
import asset35 from "../img/projectImages/7cd25ee71c93e6c266a6.webp";
import asset36 from "../img/projectImages/0ef8027cda0340bfb53e.webp";
import asset37 from "../img/projectImages/2b2f1b2d31e32c34795e.webp";
import asset38 from "../img/projectImages/852c695119cf97b29e81.webp";
import asset39 from "../img/projectImages/ecf25e0382b72c050007.webp";
import asset40 from "../img/projectImages/92896d37903b7d149fc8.webp";
import asset41 from "../img/projectImages/80b16a79416011f004e8.webp";
import asset42 from "../img/projectImages/da5584764c9c2d021420.webp";
import asset43 from "../img/projectImages/f3aeeb5ca471f4f3ab76.webp";
import asset44 from "../img/projectImages/d8efdcc77a6bc8ecfff3.webp";
import asset45 from "../img/projectImages/2a69d97f0029db068683.webp";
import asset46 from "../img/projectImages/5f47a5283dd09de39699.webp";
import asset47 from "../img/projectImages/77a580b17f867c62bfda.webp";
import asset48 from "../img/projectImages/664085fd4f966e5524cc.webp";
import asset49 from "../img/projectImages/930e9e00ca81b3669f4e.webp";
import asset50 from "../img/projectImages/cfcf6520adcf14a849cd.webp";
import asset51 from "../img/projectImages/0bf8125ef45999a37136.webp";
import asset52 from "../img/projectImages/61f64b7d8c06f19fe695.webp";
import asset53 from "../img/projectImages/01063869df316d061f11.webp";
import asset54 from "../img/projectImages/18b266784c350e3795f9.webp";
import asset55 from "../img/projectImages/acb5a82e6da84785c872.webp";
import asset56 from "../img/projectImages/5c6a48c01ee4592f5984.webp";
import asset57 from "../img/projectImages/3e7054c861dc02ae052f.webp";
import asset58 from "../img/projectImages/23a565ee0a564da349c8.webp";
import asset59 from "../img/projectImages/e41ff8aa61aec0cfd426.webp";
import asset60 from "../img/projectImages/afef8e3cd21492d0abc8.webp";
import asset61 from "../img/projectImages/e3fdf31b365568c5e582.webp";
import asset62 from "../img/projectImages/80572703826c618586fe.webp";
import asset63 from "../img/projectImages/24a9a41356e5eec56654.webp";
import asset64 from "../img/projectImages/88e0fc957981bce0bfef.webp";
import asset65 from "../img/projectImages/7593b7dedc06c649e5e2.webp";
import asset66 from "../img/projectImages/68b6fde49facfd400729.webp";
import asset67 from "../img/projectImages/b4c0ab6df06c824cce55.webp";
import asset68 from "../img/projectImages/417baf242333fad4e458.webp";
import asset69 from "../img/projectImages/e40715f4e8e2f67612cb.webp";
import asset70 from "../img/projectImages/b3462495d6614dca70df.webp";
import asset71 from "../img/projectImages/acd6ce87e5285efde286.webp";
import asset72 from "../img/projectImages/2ab205404970dc06fb97.webp";
import asset73 from "../img/projectImages/c0d351d683248e3dffc9.webp";
import asset74 from "../img/projectImages/f9f328820b82b631eba1.webp";
import asset75 from "../img/projectImages/5fcaeefc9055a82650d1.webp";
import asset76 from "../img/projectImages/e8ab75010c5526a1ccf8.webp";
import asset77 from "../img/projectImages/ed2a3d6f690599a1728f.webp";
import asset78 from "../img/projectImages/030ddfd0cf9469b2760e.webp";
import asset79 from "../img/projectImages/4cfebf7de929652f4f8e.webp";
import asset80 from "../img/projectImages/283c2653e7aaaa92779f.webp";
import asset81 from "../img/projectImages/789d3f448835e5aec1ee.webp";
import asset82 from "../img/projectImages/67b18064d7e278e52f9f.webp";
import asset83 from "../img/projectImages/dfb990442dfb7439c8a1.webp";
import asset84 from "../img/projectImages/52baaefe45c062e441a5.webp";
import asset85 from "../img/projectImages/e82dd626986401cdf22c.webp";
import asset86 from "../img/projectImages/c3bc36ba563db9b1d26b.webp";
import asset87 from "../img/projectImages/44d45a38688f87596e73.webp";
import asset88 from "../img/projectImages/8ce03a075bc009f6e7e7.webp";
import asset89 from "../img/projectImages/7d820775c7f9b0850674.webp";
import asset90 from "../img/projectImages/597e2d4d6c07cae89e56.webp";
import asset91 from "../img/projectImages/d9a44362f8c0ef0b0275.webp";
import asset92 from "../img/projectImages/5f33c48e3541605906df.webp";
import asset93 from "../img/projectImages/9c2b7ba4b43fd9e4504a.webp";
import asset94 from "../img/projectImages/ee2db670053b56cfe651.webp";
import asset95 from "../img/projectImages/81ed239bc5e4a374eaf5.webp";
import asset96 from "../img/projectImages/abc8e0af9ac6ab50b623.webp";
import asset97 from "../img/projectImages/617d7e9623e5aedd2931.webp";
import asset98 from "../img/projectImages/c8ab95be9d75b7b11007.webp";
import asset99 from "../img/projectImages/4cbaf079fdd513da6e35.webp";
import asset100 from "../img/projectImages/364cb6023f1356ac6a06.webp";
import asset101 from "../img/projectImages/e8ec1305e2cb5add5710.webp";
import asset102 from "../img/projectImages/3e9faa24a74348d52c18.webp";
import asset103 from "../img/projectImages/b2e3578f30631afb9e6e.webp";
import asset104 from "../img/projectImages/d194c44b721fee987e90.webp";
import asset105 from "../img/projectImages/a26e013f1b6e89b2f68f.webp";
import asset106 from "../img/projectImages/6b831a6897af3e5389af.webp";
import asset107 from "../img/projectImages/f85ea02f5a48d0a69ce9.webp";
import asset108 from "../img/projectImages/363e54505b70f096f7f9.webp";
import asset109 from "../img/projectImages/2000323f16c852046b29.webp";
import asset110 from "../img/projectImages/52006910d4a5342baa92.webp";
import asset111 from "../img/projectImages/048a4dfbe58d46923958.webp";
import asset112 from "../img/projectImages/274bd791fc45e50bb1f2.webp";
import asset113 from "../img/projectImages/4f103d6842556daec3c8.webp";
import asset114 from "../img/projectImages/74d12843263cfd2433a8.webp";
import asset115 from "../img/projectImages/84aa07ce61f20003a054.webp";
import asset116 from "../img/projectImages/ad7a6b4a69049c9fea43.webp";
import asset117 from "../img/projectImages/ee89a034e5d196b80154.webp";
import asset118 from "../img/projectImages/62eb534068c8c902ec25.webp";
import asset119 from "../img/projectImages/190b781c3cf0f418aa9a.webp";
import asset120 from "../img/projectImages/be8ad9a0aba7093c480f.webp";
import asset121 from "../img/projectImages/d593a4347ccb84c31590.webp";
import asset122 from "../img/projectImages/231b7075ad6b0528edff.webp";
import asset123 from "../img/projectImages/f5f2d6fb63db0319e025.webp";
import asset124 from "../img/projectImages/e4175ae2f804aed97228.webp";
import asset125 from "../img/projectImages/b718f5011628880a9c7b.webp";
import asset126 from "../img/projectImages/e37da67484f71da75b50.webp";
import asset127 from "../img/projectImages/fb94ad85413f3204a5e9.webp";
import asset128 from "../img/projectImages/302388af95c1b64a6def.webp";
import asset129 from "../img/projectImages/3b95131105a06b86be09.webp";
import asset130 from "../img/projectImages/74c9c02f107985ae20b0.webp";
import asset131 from "../img/projectImages/07c73c62e736a7cc0062.webp";
import asset132 from "../img/projectImages/2ad2812045742806ff23.webp";
import asset133 from "../img/projectImages/e95c49bc65da03dd85e5.webp";
import asset134 from "../img/projectImages/2669bf6567fa32802a75.webp";
import asset135 from "../img/projectImages/92e45577a33861ddb434.webp";
import asset136 from "../img/projectImages/7f771f2fa1baa24fc8a7.webp";
import asset137 from "../img/projectImages/1ce23cc92fd99642261d.webp";
import asset138 from "../img/projectImages/8683721409df4e1c6b3a.webp";
import asset139 from "../img/projectImages/d699cf6ee8f6657ca780.webp";
import asset140 from "../img/projectImages/557d0d1f269a78f420b3.webp";
import asset141 from "../img/projectImages/3cd8ee89f6599921441e.webp";
import asset142 from "../img/projectImages/4a645431a0c7a1d22cc6.webp";
import asset143 from "../img/projectImages/f029f4a1ec30622a0abf.webp";
import asset144 from "../img/projectImages/12252e45b959a45c5a74.webp";
import asset145 from "../img/projectImages/abfc3dcf86bce435b2b1.webp";
import asset146 from "../img/projectImages/7d7ff5a0e7079cfbd870.webp";
import asset147 from "../img/projectImages/c432fe5c3f5e5aa2ce47.webp";
import asset148 from "../img/projectImages/950431d85e0ec439512f.webp";
import asset149 from "../img/projectImages/59da93d162e2c770b803.webp";
import asset150 from "../img/projectImages/be56527dcce257f2b19f.webp";
import asset151 from "../img/projectImages/12930507eaeefce26e66.webp";
import asset152 from "../img/projectImages/3fb4d55f4856090452b5.webp";
import asset153 from "../img/projectImages/2f6c69cd745446f41668.webp";
import asset154 from "../img/projectImages/2e85eafd56d534b25c3a.webp";
import asset155 from "../img/projectImages/b5a6cfb26bf175e4f6d2.webp";
import asset156 from "../img/projectImages/e5c4020fcc1dd133dba7.webp";
import asset157 from "../img/projectImages/6b6754fcd8b430a6ac30.webp";
import asset158 from "../img/projectImages/1cc23b3afaf7ffbb40b2.webp";
import asset159 from "../img/projectImages/d9dd1ff52ae8cca5060b.webp";
import asset160 from "../img/projectImages/c414a7607d416ab4763f.webp";
import asset161 from "../img/projectImages/aabce78f4ebe89137b61.webp";
import asset162 from "../img/projectImages/4f93c25df84330a91919.webp";
import asset163 from "../img/projectImages/1f827ccf8a17ecc8496c.webp";
import asset164 from "../img/projectImages/44231ad77d4b994fe0cb.webp";
import asset165 from "../img/projectImages/60cc5c66164a060cb56e.webp";
import asset166 from "../img/projectImages/945a62ec65159b170fcc.webp";
import asset167 from "../img/projectImages/80c9ad82ee954fba118b.webp";
import asset168 from "../img/projectImages/092c0b864745eed47706.webp";
import asset169 from "../img/projectImages/40797b738d44bc002053.webp";
import asset170 from "../img/projectImages/ce527d8ead9e36f3f61b.webp";
import asset171 from "../img/projectImages/4458fdf1b067b599ff03.webp";
import asset172 from "../img/projectImages/639bde15f37a6295b76a.webp";
import asset173 from "../img/projectImages/6ce3ea4e8699ec8459c5.webp";
import asset174 from "../img/projectImages/516cf0636b287bd8eafa.webp";
import asset175 from "../img/projectImages/9fd556c157db2e57c002.webp";
import asset176 from "../img/projectImages/fe3fafb1e9126ebfbe08.webp";
import asset177 from "../img/projectImages/f917e77ca289e3e3f8fc.webp";
import asset178 from "../img/projectImages/b5c72edabcbb2f5cb6fa.webp";
import asset179 from "../img/projectImages/d03693d1c48dab9b29e6.webp";
import asset180 from "../img/projectImages/e6791f959e4c83d7ff60.webp";
import asset181 from "../img/projectImages/443a92a282c329ef07d8.webp";
import asset182 from "../img/projectImages/f279fe2f7f0a4e40b4ec.webp";
import asset183 from "../img/projectImages/ad10a12ff78a281d9010.webp";
import asset184 from "../img/projectImages/f0708c20122f8524a5a1.webp";
import asset185 from "../img/projectImages/f1aeaa4b6ccb790c0fe3.webp";
import asset186 from "../img/projectImages/c52dd960e0d1ca903efd.webp";
import asset187 from "../img/projectImages/2a853b0c4a9935fbdd88.webp";
import asset188 from "../img/projectImages/dedaf544fa84a0cb1349.webp";
import asset189 from "../img/projectImages/9a9947243a5030ca622e.webp";
import asset190 from "../img/projectImages/4afc584477e609cd7c3f.webp";
import asset191 from "../img/projectImages/264f9bc9fd4b5f83170c.webp";
import asset192 from "../img/projectImages/7e8d6325b5635f17d2fa.webp";
import asset193 from "../img/projectImages/c502d0266d89366396a5.webp";
import asset194 from "../img/projectImages/92e405bef967828aad4f.webp";
import asset195 from "../img/projectImages/5fde6de2b091a9728447.webp";
import asset196 from "../img/projectImages/a85ec182cc713b353f39.webp";
import asset197 from "../img/projectImages/a27d13d61da1e221944d.webp";
import asset198 from "../img/projectImages/84b7a03e06e48cc76297.webp";
import asset199 from "../img/projectImages/c5ebd552951f59a532ab.webp";
import asset200 from "../img/projectImages/7adf937ecfe6bf178538.webp";
import asset201 from "../img/projectImages/d95459a4ce55f71eca52.webp";
import asset202 from "../img/projectImages/f9ae6f098ba5fbad9047.webp";
import asset203 from "../img/projectImages/5feaa0522761f0dfb726.webp";
import asset204 from "../img/projectImages/e1ca37aa8aaedcb664a4.webp";
import asset205 from "../img/projectImages/672da7cc890f6836e2eb.webp";
import asset206 from "../img/projectImages/a02a5ec575f8ada4a776.webp";
import asset207 from "../img/projectImages/63eec179f3b787a6dc36.webp";
import asset208 from "../img/projectImages/83e68caecdb585bb3659.webp";
import asset209 from "../img/projectImages/fa95fefd32f0362ec800.webp";
import asset210 from "../img/projectImages/36c8da92cee6855eae06.webp";
import asset211 from "../img/projectImages/48f201896b92205b7521.webp";
import asset212 from "../img/projectImages/aa96d22c63d02feabf56.webp";
import asset213 from "../img/projectImages/e5c007d7e808459913d1.webp";
import asset214 from "../img/projectImages/3694411b45c8ac9ac87d.webp";
import asset215 from "../img/projectImages/ccdc6af34de1ef319be0.webp";
import asset216 from "../img/projectImages/8e6bc912517428f69f87.webp";
import asset217 from "../img/projectImages/57f4201640cdfb7c84f2.webp";
import asset218 from "../img/projectImages/7929b924c1f15180102b.webp";
import asset219 from "../img/projectImages/31ccd4bc1a788b73bc61.webp";
import asset220 from "../img/projectImages/e1a0d60d217d99d1f86e.webp";
import asset221 from "../img/projectImages/05751947f4be18ebf794.webp";
import asset222 from "../img/projectImages/a43377573fba6722db0e.webp";
import asset223 from "../img/projectImages/2a4b25957ef5bfc3d578.webp";
import asset224 from "../img/projectImages/9e5c0806772639f2b8ac.webp";
import asset225 from "../img/projectImages/3dac2ce8e4427bd2fca1.webp";
import asset226 from "../img/projectImages/3983bfe5e8673f463e8c.webp";
import asset227 from "../img/projectImages/92d6c3aeb65aed3ae8f8.webp";
import asset228 from "../img/projectImages/e9188faf567f977b32cb.webp";
import asset229 from "../img/projectImages/423e321f645a1da8ead1.webp";
import asset230 from "../img/projectImages/08994e91402ddf6bdd45.webp";
import asset231 from "../img/projectImages/2a71972e1e4913eb2ad6.webp";
import asset232 from "../img/projectImages/7c08d311445e81a92c11.webp";
import asset233 from "../img/projectImages/f54bfb4df5c65f08a66b.webp";
import asset234 from "../img/projectImages/544ed04896635a49f65b.webp";
import asset235 from "../img/projectImages/eb1955c66ace5fddfe22.webp";
import asset236 from "../img/projectImages/f7bef790f2c1addcc7f0.webp";
import asset237 from "../img/projectImages/2baa02a4d31beb7296c5.webp";
import asset238 from "../img/projectImages/08485db7c3992d146604.webp";
import asset239 from "../img/projectImages/162b4d9fb5a3cf67c576.webp";
import asset240 from "../img/projectImages/f8291803e219a2f8aafb.webp";
import asset241 from "../img/projectImages/ed569a04b1d9ba63c743.webp";
import asset242 from "../img/projectImages/3327c142033d35652f1c.webp";
import asset243 from "../img/projectImages/8ecf272f5492293aa068.webp";
import asset244 from "../img/projectImages/5a8a9a5e7f27d30f983e.webp";
import asset245 from "../img/projectImages/d598c2243edaeecf35b9.webp";
import asset246 from "../img/projectImages/79bc9e4c0bee19a95f43.webp";
import asset247 from "../img/projectImages/cd7bd767dd788785019b.webp";
import asset248 from "../img/projectImages/7002c7f3469f9145aef1.webp";
import asset249 from "../img/projectImages/538ee196d01f8b567bb6.webp";
import asset250 from "../img/projectImages/db5b387182e94110728c.webp";
import asset251 from "../img/projectImages/336ad0f83fefbf175f23.webp";
import asset252 from "../img/projectImages/deaee18edbe4a4cdc65f.webp";
import asset253 from "../img/projectImages/7bae51b74e7ee9b60d80.webp";
import asset254 from "../img/projectImages/268a4364415b19974611.webp";
import asset255 from "../img/projectImages/2147dd125d7f64cb9ea1.webp";
import asset256 from "../img/projectImages/2901633ba8c10345d39d.webp";
import asset257 from "../img/projectImages/12519364a9df6b9fa379.webp";
import asset258 from "../img/projectImages/d6fc9af39c6d55e709a5.webp";
import asset259 from "../img/projectImages/9c5ea89572cf13c97c52.webp";
import asset260 from "../img/projectImages/2e7951b2eae59723d200.webp";
import asset261 from "../img/projectImages/7d10bddd4989cb0089e8.webp";
import asset262 from "../img/projectImages/6f4c1ae831f2c09abc99.webp";
import asset263 from "../img/projectImages/b7bcffad531a6a0921a8.webp";
import asset264 from "../img/projectImages/edf8500463285f595678.webp";
import asset265 from "../img/projectImages/6e6347f9393353db7aa9.webp";
import asset266 from "../img/projectImages/d250f5ba514e22b8ac8b.webp";
import asset267 from "../img/projectImages/b31e38034ede956d2cbc.webp";
import asset268 from "../img/projectImages/28a49668a80aec473a34.webp";
import asset269 from "../img/projectImages/71e585ed8016ea2c9170.webp";
import asset270 from "../img/projectImages/05ecdd291cf2eea6b207.webp";
import asset271 from "../img/projectImages/beab1d694d34cf3e3da2.webp";
import asset272 from "../img/projectImages/0c61ffd914ae2f46aadd.webp";
import asset273 from "../img/projectImages/4103215193cc1e2ef3ea.webp";
import asset274 from "../img/projectImages/a8a999fc303247933b77.webp";
import asset275 from "../img/projectImages/e2e8ffcc9bfa341a64b4.webp";
import asset276 from "../img/projectImages/e004ded6538ee70365fc.webp";
import asset277 from "../img/projectImages/e4d574437758e352398c.webp";
import asset278 from "../img/projectImages/a7d2bdf5221fda4c2e7d.webp";
import asset279 from "../img/projectImages/a7fc3a309ae1460d58d4.webp";
import asset280 from "../img/projectImages/ee52cfb287dc5b26f76c.webp";
import asset281 from "../img/projectImages/cfba08fe364a53dbc242.webp";
import asset282 from "../img/projectImages/3f4871358b7f214684dd.webp";
import asset283 from "../img/projectImages/3baff6807e938b0442ae.webp";
import asset284 from "../img/projectImages/1230af6e9aa95b9e711a.webp";
import asset285 from "../img/projectImages/9281df6b15b4a5c914fd.webp";
import asset286 from "../img/projectImages/09e7a4ec0c1e77f407c5.webp";
import asset287 from "../img/projectImages/59098b872bc79ef0f10e.webp";
import asset288 from "../img/projectImages/c54f1413b50d5c335ced.webp";
import asset289 from "../img/projectImages/428ce198f616766e51b0.webp";
import asset290 from "../img/projectImages/89d9c3dadfdb36bcf82f.webp";
import asset291 from "../img/projectImages/b8908aa8b681c5b01e63.webp";
import asset292 from "../img/projectImages/b690f25bfe21ddf9953d.webp";
import asset293 from "../img/projectImages/d63122e6ad24fa8d15ab.webp";
import asset294 from "../img/projectImages/d6812052dcbc058ab9a2.webp";
import asset295 from "../img/projectImages/fa26ce540bd2d9a3c841.webp";
import asset296 from "../img/projectImages/661a793a415feb549a29.webp";
import asset297 from "../img/projectImages/71acd9de885fad9f00bc.webp";
import asset298 from "../img/projectImages/12600d07366df74b9dd8.webp";
import asset299 from "../img/projectImages/157ada47b6e31c6efc11.webp";
import asset300 from "../img/projectImages/2f94cb40e9b82831d464.webp";
import asset301 from "../img/projectImages/3d95de9ddccb7fcd315f.webp";
import asset302 from "../img/projectImages/78b970107db3833af91f.webp";
import asset303 from "../img/projectImages/5b5fe2ece7dbc495d306.webp";
import asset304 from "../img/projectImages/d377f9696b702be97674.webp";
import asset305 from "../img/projectImages/de2c0c4b1371847827f9.webp";
import asset306 from "../img/projectImages/fdcd28618e57ac0d5546.webp";
import asset307 from "../img/projectImages/16c4960904b04171fc1a.webp";
import asset308 from "../img/projectImages/16b6673333ebbdfc12b2.webp";
import asset309 from "../img/projectImages/a37d8dd4b943c508adfe.webp";
import asset310 from "../img/projectImages/aba353dfc893d8574a5e.webp";
import asset311 from "../img/projectImages/98b9bc18d4279250622d.webp";
import asset312 from "../img/projectImages/b8c67bd6eb240178c484.webp";
import asset313 from "../img/projectImages/5cecbcc7a7af765fa003.webp";
import asset314 from "../img/projectImages/b8301fac97eda2a9c48a.webp";
import asset315 from "../img/projectImages/ceb06c165c77d90cf2b0.webp";
import asset316 from "../img/projectImages/3876c614b68c650c247a.webp";
import asset317 from "../img/projectImages/15e413301772ce663d10.webp";
import asset318 from "../img/projectImages/e37eab63b7c8e9d6acf7.webp";
import asset319 from "../img/projectImages/8e6c6e79277cd8a659cf.webp";
import asset320 from "../img/projectImages/2c1f500747b98ba89e1c.webp";
import asset321 from "../img/projectImages/e35470deeaa13357af58.webp";
import asset322 from "../img/projectImages/d7dcfe3b3d05c44eb539.webp";
import asset323 from "../img/projectImages/c3299f78f082b1b5d020.webp";
import asset324 from "../img/projectImages/aef4688fb7d9ed817c05.webp";
import asset325 from "../img/projectImages/415798df4c6cfe246bf1.webp";
import asset326 from "../img/projectImages/397ca9fc53486d47e274.webp";
import asset327 from "../img/projectImages/e416411b96e3895a9ce3.webp";
import asset328 from "../img/projectImages/ec09c6e154289c1eec05.webp";
import asset329 from "../img/projectImages/63f83713caf847db4031.webp";
import asset330 from "../img/projectImages/08a44f5ec178100aa372.webp";
import asset331 from "../img/projectImages/f0e1bf94b9eceed1202e.webp";
import asset332 from "../img/projectImages/7e516d4884782cb5b693.webp";
import asset333 from "../img/projectImages/d398849a406f09d8bbaf.webp";
import asset334 from "../img/projectImages/3609e3e03cb5a0e32e8a.webp";
import asset335 from "../img/projectImages/50b3321caf228bbef030.webp";
import asset336 from "../img/projectImages/b9514796091948591a49.webp";
import asset337 from "../img/projectImages/0f545fca392841c4177f.webp";
import asset338 from "../img/projectImages/07bce6e4bebe319383e5.webp";
import asset339 from "../img/projectImages/79eacf9963604d21d390.webp";
import asset340 from "../img/projectImages/11f344c338ed110cc1c1.webp";
import asset341 from "../img/projectImages/6d431bcf005d92132740.webp";
import asset342 from "../img/projectImages/f10482355e948db3eef7.webp";
import asset343 from "../img/projectImages/bcc014fd712534b59e67.webp";
import asset344 from "../img/projectImages/efdfb59e6fc554dd6fec.webp";
import asset345 from "../img/projectImages/1d77ec3447203b20949d.webp";
import asset346 from "../img/projectImages/e416903115afd3d3c097.webp";
import asset347 from "../img/projectImages/43c4ecfa59e9303002f4.webp";
import asset348 from "../img/projectImages/4d0b4eaf938ffcce774c.webp";
import asset349 from "../img/projectImages/8873c6cb5a9a00cfcc7b.webp";
import asset350 from "../img/projectImages/b5d7914e75bedeec8d1e.webp";
import asset351 from "../img/projectImages/4814397abe2d44a5a21c.webp";
import asset352 from "../img/projectImages/e2693c64b153f7a7f983.webp";
import asset353 from "../img/projectImages/47556a951a0f69dc75b2.webp";
import asset354 from "../img/projectImages/c2bf448d81b4bdc5eede.webp";
import asset355 from "../img/projectImages/e3827a437f38bb385742.webp";
import asset356 from "../img/projectImages/64473a35eedb1a3ea0cc.webp";
import asset357 from "../img/projectImages/8d97c1137552afd692c3.webp";
import asset358 from "../img/projectImages/a4048a7a222dbd552c63.webp";
import asset359 from "../img/projectImages/dd5da8f172fecab89c2e.webp";
import asset360 from "../img/projectImages/a266ffc74ec28c98d18f.webp";
import asset361 from "../img/projectImages/5618444124e1ba062466.webp";
import asset362 from "../img/projectImages/bf94e0da010e3dcbca80.webp";
import asset363 from "../img/projectImages/1ee73c84bf79f44a4fd4.webp";
import asset364 from "../img/projectImages/224ebf563db56622e54c.webp";
import asset365 from "../img/projectImages/a571ca5438ec30c13439.webp";
import asset366 from "../img/projectImages/06afe3982f9ccdc7b41f.webp";
import asset367 from "../img/projectImages/091a86d7e6349931e0c6.webp";
import asset368 from "../img/projectImages/4cd5064a193a90901cb9.webp";
import asset369 from "../img/projectImages/9340fc17ee49e971f2b4.webp";
import asset370 from "../img/projectImages/0b28d185fa281bfb2a02.webp";
import asset371 from "../img/projectImages/0dd545f105b40b002c9c.webp";
import asset372 from "../img/projectImages/f9218b3e218f0942c56a.webp";
import asset373 from "../img/projectImages/f8671394c1b3b7da809c.webp";
import asset374 from "../img/projectImages/04720d886590e755a876.webp";
import asset375 from "../img/projectImages/6f4aab4ff014904cb5f6.webp";
import asset376 from "../img/projectImages/f743132c9dd0f0b081fe.webp";
import asset377 from "../img/projectImages/eee77c81e98b2d7500bd.webp";
import asset378 from "../img/projectImages/dfdc5702731880d003a2.webp";
import asset379 from "../img/projectImages/0f9d7cfb76991d8e4408.webp";
import asset380 from "../img/projectImages/a8956898da1d9e145421.webp";
import asset381 from "../img/projectImages/05887285343a297c3c2c.webp";
import asset382 from "../img/projectImages/9ea37004ca80c2b28047.webp";
import asset383 from "../img/projectImages/8629fc68be80404ea443.webp";
import asset384 from "../img/projectImages/a18a4c2c20780dc6dac6.webp";
import asset385 from "../img/projectImages/9a66c077e25e0b0ed34e.webp";
import asset386 from "../img/projectImages/ffe71bb927ffdadbfec8.webp";
import asset387 from "../img/projectImages/5859cc15b9c8ab8195e8.webp";
import asset388 from "../img/projectImages/49db215fe0926a4b6b80.webp";
import asset389 from "../img/projectImages/25403d3d71f05aa7285e.webp";
import asset390 from "../img/projectImages/ce454fdbf07213b45449.webp";
import asset391 from "../img/projectImages/f1c0c861664a4118f273.webp";
import asset392 from "../img/projectImages/237ac810f96375ec6d17.webp";
import asset393 from "../img/projectImages/74a6f1978c20de05486d.webp";
import asset394 from "../img/projectImages/5f03d3dfc7b6d079c09f.webp";
import asset395 from "../img/projectImages/1b762368219126d04555.webp";
import asset396 from "../img/projectImages/bd3242d85baef5a349ed.webp";
import asset397 from "../img/projectImages/1d8a72adda27ec00698a.webp";
import asset398 from "../img/projectImages/ac0b4dc907db57c4b466.webp";
import asset399 from "../img/projectImages/e63e68b532f058b3bcba.webp";
import asset400 from "../img/projectImages/e3c990d919d44a8761ff.webp";
import asset401 from "../img/projectImages/97cd4f1b1b98fae0c98a.webp";
import asset402 from "../img/projectImages/0777bc7947c7ba78823d.webp";
import asset403 from "../img/projectImages/74bf32b382de88f40779.webp";
import asset404 from "../img/projectImages/4922f37504ac93c6be12.webp";
import asset405 from "../img/projectImages/2f1cb81e0acd83c6562e.webp";
import asset406 from "../img/projectImages/dee877c09fb8a7f7aa12.webp";
import asset407 from "../img/projectImages/3f2d416eb369506e59a9.webp";
import asset408 from "../img/projectImages/d6da966183b819fc340b.webp";
import asset409 from "../img/projectImages/42b3f36134ab334dc00f.webp";
import asset410 from "../img/projectImages/7ab640d8e55f580889af.webp";
import asset411 from "../img/projectImages/2ee27a8d7244df115c34.webp";
import asset412 from "../img/projectImages/6652acc1f43ae03c10d8.webp";
import asset413 from "../img/projectImages/4645f3501ed8bc27e226.webp";
import asset414 from "../img/projectImages/3f90a590a634069761c1.webp";
import asset415 from "../img/projectImages/55251f63adcd7c836535.webp";
import asset416 from "../img/projectImages/dd4ec7d775dc3fd10479.webp";
import asset417 from "../img/projectImages/0b95bc1bb7ee95453333.webp";
import asset418 from "../img/projectImages/838c41a67edfdba8bd12.webp";
import asset419 from "../img/projectImages/f38244620101cff81adb.webp";
import asset420 from "../img/projectImages/be943cfa6a6207d1ea5f.webp";
import asset421 from "../img/projectImages/8858798f9f1571cedf87.webp";
import asset422 from "../img/projectImages/38a4fc8dea5365b31153.webp";
import asset423 from "../img/projectImages/1542e8027bde5fd32c5b.webp";
import asset424 from "../img/projectImages/1629306cd13c25c6c7d9.webp";
import asset425 from "../img/projectImages/7a8f1008cacb57e03ccc.webp";
import asset426 from "../img/projectImages/52b7bb043e5ecfd3a27c.webp";
import asset427 from "../img/projectImages/dea3d4edae32b717284a.webp";
import asset428 from "../img/projectImages/f40478ab3bd91edf2c34.webp";
import asset429 from "../img/projectImages/75fbc20f781d9aacb508.webp";
import asset430 from "../img/projectImages/f0cf2316121378689b44.webp";
import asset431 from "../img/projectImages/2408d99ffd9fddb9c7f3.webp";
import asset432 from "../img/projectImages/df1dd29fdeb2be559a53.webp";
import asset433 from "../img/projectImages/f7c0adff3f82f6935271.webp";
import asset434 from "../img/projectImages/4513d686ec5a7e2e827b.webp";
import asset435 from "../img/projectImages/257bff438289c0580047.webp";
import asset436 from "../img/projectImages/2cb9ab3e689b2f3e7acf.webp";
import asset437 from "../img/projectImages/99c7d1791ff70d4f5854.webp";
import asset438 from "../img/projectImages/083597340ffa1e2fa5a3.webp";
import asset439 from "../img/projectImages/484e09f84803a35fb4a3.webp";
import asset440 from "../img/projectImages/b8714bf622f752ef63a7.webp";
import asset441 from "../img/projectImages/cb95c90ead07594dc992.webp";
import asset442 from "../img/projectImages/f830252ab3949e0f29dd.webp";
import asset443 from "../img/projectImages/43a7b19afe1294c58284.webp";
import asset444 from "../img/projectImages/1377642a3728d665033a.webp";
import asset445 from "../img/projectImages/285c7a7e2afb53105dab.webp";
import asset446 from "../img/projectImages/4308f77e649dc077bf04.webp";
import asset447 from "../img/projectImages/b84711836d72b26da427.webp";
import asset448 from "../img/projectImages/8748334e2c29f174c658.webp";
import asset449 from "../img/projectImages/0935b1143400f0e738ee.webp";
import asset450 from "../img/projectImages/10841937c54fa5a65a13.webp";
import asset451 from "../img/projectImages/77b3260c088f01600578.webp";
import asset452 from "../img/projectImages/6b547188868b24e0714b.webp";
import asset453 from "../img/projectImages/4bb636b997af5d6957c0.webp";
import asset454 from "../img/projectImages/53c895f9dd0cab86cd54.webp";
import asset455 from "../img/projectImages/d222bbc73cc2250fd07b.webp";
import asset456 from "../img/projectImages/66d3ffb734b103b8a760.webp";
import asset457 from "../img/projectImages/2cb0ccd4923b0d4ef8a6.webp";
import asset458 from "../img/projectImages/d231e3b5360d2e749369.webp";
import asset459 from "../img/projectImages/44950b5b872fc1ce9e46.webp";
import asset460 from "../img/projectImages/c38d6ee5fec1d37991a4.webp";
import asset461 from "../img/projectImages/e950dd91f57a427d6eec.webp";
import asset462 from "../img/projectImages/e21ab11d3c5478a2894f.webp";
import asset463 from "../img/projectImages/98bdf5f839925f124f4a.webp";
import asset464 from "../img/projectImages/76006481132a18feb693.webp";
import asset465 from "../img/projectImages/ef6e32436f388ed11fe7.webp";
import asset466 from "../img/projectImages/25b52d6acf143c15270e.webp";
import asset467 from "../img/projectImages/db4ff90fecdd3bc972c6.webp";
import asset468 from "../img/projectImages/dae5694f76bbebc01cd5.webp";
import asset469 from "../img/projectImages/6bdcf89d328ef4172788.webp";
import asset470 from "../img/projectImages/4dd052b224f715b80a33.webp";
import asset471 from "../img/projectImages/1f63c5e528e895d8e614.webp";
import asset472 from "../img/projectImages/22877affa0879d6cd61f.webp";
import asset473 from "../img/projectImages/1195083ec088a96f39c3.webp";
import asset474 from "../img/projectImages/162e3143b1b8e6b77aa2.webp";
import asset475 from "../img/projectImages/09c690af9d3bdec01e61.webp";
import asset476 from "../img/projectImages/c3dd80c71c5439d45da3.webp";
import asset477 from "../img/projectImages/e89d543e6d8aa350cd02.webp";
import asset478 from "../img/projectImages/37bea418548babab052f.webp";
import asset479 from "../img/projectImages/fe60c44f22c7bcce51ab.webp";
import asset480 from "../img/projectImages/a953e1c7c0b394368773.webp";
import asset481 from "../img/projectImages/e87c593c330c2c5f7c54.webp";
import asset482 from "../img/projectImages/9de54da62c07390f91dd.webp";
import asset483 from "../img/projectImages/dbc2fc49c8985b8bd052.webp";
import asset484 from "../img/projectImages/5097699873d440ff8d50.webp";
import asset485 from "../img/projectImages/4014e96e928148def082.webp";
import asset486 from "../img/projectImages/11bd5f6df29409fa72ce.webp";
import asset487 from "../img/projectImages/bf8f959314e5a11550ba.webp";
import asset488 from "../img/projectImages/5027ea1cebe658dd3c0b.webp";
import asset489 from "../img/projectImages/c32538f46fbfcf9571ce.webp";
import asset490 from "../img/projectImages/6f599fe727ff63c81aea.webp";
import asset491 from "../img/projectImages/5cfc3c313f4848d62bf7.webp";
import asset492 from "../img/projectImages/1b7c9449a0a71207e788.webp";
import asset493 from "../img/projectImages/de2e1e84d47331f9d56c.webp";
import asset494 from "../img/projectImages/4859447743492eeba2b4.webp";
import asset495 from "../img/projectImages/7e743a2594e7007964cf.webp";
import asset496 from "../img/projectImages/1bb4b57ed6606068c73e.webp";
import asset497 from "../img/projectImages/dcec6bee8c9f752545e2.webp";
import asset498 from "../img/projectImages/139d6c181e86682f8955.webp";
import asset499 from "../img/projectImages/231b4a0902ae0de0830e.webp";
import asset500 from "../img/projectImages/3dd83f05d8c6f9545538.webp";
import asset501 from "../img/projectImages/90e096b5d398b6c38848.webp";
import asset502 from "../img/projectImages/aa74b445762d15cd7376.webp";
import asset503 from "../img/projectImages/66effeece9d57a2c6c4e.webp";
import asset504 from "../img/projectImages/07384d01760467cd872d.webp";
import asset505 from "../img/projectImages/07945cbe893c59f72709.webp";
import asset506 from "../img/projectImages/2faab68e7cb498d26a31.webp";
import asset507 from "../img/projectImages/567ee903bee0a7efd529.webp";
import asset508 from "../img/projectImages/633ad2c2b4b099bfe7c6.webp";
import asset509 from "../img/projectImages/c65e93724d86aaf707ab.webp";
import asset510 from "../img/projectImages/4350573f665f46776df8.webp";
import asset511 from "../img/projectImages/24fd1741a12976e6a8ef.webp";
import asset512 from "../img/projectImages/561df9f73c8072ad74d3.webp";
import asset513 from "../img/projectImages/4d050c745a6ebecc5238.webp";
import asset514 from "../img/projectImages/3fe39bb1bbccd1eefd68.webp";
import asset515 from "../img/projectImages/5368c53cc7ba9bcb1371.webp";
import asset516 from "../img/projectImages/b9241ccede1ab1171b4a.webp";
import asset517 from "../img/projectImages/604e741aa385ad1241f7.webp";
import asset518 from "../img/projectImages/eb8661aecd8ae91be655.webp";
import asset519 from "../img/projectImages/059864738aee5cf60233.webp";
import asset520 from "../img/projectImages/0af36fa169f3ff95207a.webp";
import asset521 from "../img/projectImages/939a4acede2602bf55a4.webp";
import asset522 from "../img/projectImages/347b4c13dae36dd8d541.webp";
import asset523 from "../img/projectImages/bd23325131ae3967ac16.webp";
import asset524 from "../img/projectImages/6dbf7a7185b7f86ed9c4.webp";
import asset525 from "../img/projectImages/7ef630a44c3895a10057.webp";
import asset526 from "../img/projectImages/2696000c5450f4969ec7.webp";
import asset527 from "../img/projectImages/4847bebd89a391a9f81e.webp";
import asset528 from "../img/projectImages/fe37ffc2a36c7d9cda46.webp";
import asset529 from "../img/projectImages/695733fc6af6c7de2caf.webp";
import asset530 from "../img/projectImages/01229749b47e91b80b86.webp";
import asset531 from "../img/projectImages/820c497e9f4645944866.webp";
import asset532 from "../img/projectImages/14b1c871a45c7310b58b.webp";
import asset533 from "../img/projectImages/f7e1420c1fa6e0d1efba.webp";
import asset534 from "../img/projectImages/7daf4ec6eb2d73b82925.webp";
import asset535 from "../img/projectImages/06af29e16e1997cca463.webp";
import asset536 from "../img/projectImages/6b8667312ae46d31f966.webp";
import asset537 from "../img/projectImages/4136e288a5fdb6d7101c.webp";
import asset538 from "../img/projectImages/238c9ab7ceb0b71cb858.webp";
import asset539 from "../img/projectImages/5012bb4a0ddfd7f0e080.webp";
import asset540 from "../img/projectImages/871e071872dcf67bb49a.webp";
import asset541 from "../img/projectImages/0814fc6940baf70e48a8.webp";
import asset542 from "../img/projectImages/758f3f4745a758b49e23.webp";
import asset543 from "../img/projectImages/8c7f9b2c6ccfb096e52e.webp";
import asset544 from "../img/projectImages/4d6f24ec9d215f9b909f.webp";
import asset545 from "../img/projectImages/816b2f999bd64b1d3bbb.webp";
import asset546 from "../img/projectImages/6c00e9dd0715a5ebbf55.webp";
import asset547 from "../img/projectImages/25ca6d5dd5efe39004ad.webp";
import asset548 from "../img/projectImages/2b23a4448a78a20e8f51.webp";
import asset549 from "../img/projectImages/4477feefe69196fb3c00.webp";
import asset550 from "../img/projectImages/7075ed62ea7b4b6e8f6e.webp";
import asset551 from "../img/projectImages/2a4c903ed9d21d8b5ea1.webp";
import asset552 from "../img/projectImages/04a8878a4955536bdef1.webp";
import asset553 from "../img/projectImages/975936368bae59b89f5d.webp";
import asset554 from "../img/projectImages/5b294d37ce7f36b66c86.webp";
import asset555 from "../img/projectImages/2821b4bb5648c8afeb1b.webp";
import asset556 from "../img/projectImages/67248e8bed464c85b011.webp";
import asset557 from "../img/projectImages/cd328fe907d544db6598.webp";
import asset558 from "../img/projectImages/bed197a06d643697fb56.webp";
import asset559 from "../img/projectImages/0868f0192940768a34ab.webp";
import asset560 from "../img/projectImages/50c42998c80c63ba6a87.webp";
import asset561 from "../img/projectImages/8bfaed2b738392d6e9c5.webp";
import asset562 from "../img/projectImages/b7ade85cc197e3450a22.webp";
import asset563 from "../img/projectImages/6c6c1ee58eaf02d2aa35.webp";
import asset564 from "../img/projectImages/4a146c9aa6a17270c267.webp";
import asset565 from "../img/projectImages/4630b1c333b131aef16b.webp";
import asset566 from "../img/projectImages/51994bf943bcd864a1bd.webp";
import asset567 from "../img/projectImages/5060339583dc7843d0b9.webp";
import asset568 from "../img/projectImages/d4b989a5d5638e99d4fd.webp";
import asset569 from "../img/projectImages/af70212f722eb67a1250.webp";
import asset570 from "../img/projectImages/77ad2263fea5bd485ef7.webp";
import asset571 from "../img/projectImages/e3246dd13f121b0b39e9.webp";
import asset572 from "../img/projectImages/8e7681998e1897282268.webp";
import asset573 from "../img/projectImages/749a3d081420a2f51ea9.webp";
import asset574 from "../img/projectImages/71aa3c83c05bee7ae7ee.webp";
import asset575 from "../img/projectImages/4ed7d398272efb7b9609.webp";
import asset576 from "../img/projectImages/1fd6a1a550a8006fdcbd.webp";
import asset577 from "../img/projectImages/81bae837830ffa3aed0d.webp";
import asset578 from "../img/projectImages/ce6824d127388b9a51ac.webp";
import asset579 from "../img/projectImages/9c423a3e4203fd693bf7.webp";
import asset580 from "../img/projectImages/0ac77a0746407e7508c3.webp";
import asset581 from "../img/projectImages/49ff605670de0d6769b7.webp";
import asset582 from "../img/projectImages/0f51ca48d6b6f0b03050.webp";
import asset583 from "../img/projectImages/5346307c458e21d549aa.webp";
import asset584 from "../img/projectImages/57a2b81a132c0084ecc8.webp";
import asset585 from "../img/projectImages/14fa9257bd99560d7787.webp";
import asset586 from "../img/projectImages/4760599031ed25ae0b7e.webp";
import asset587 from "../img/projectImages/44d30e070dcb8b890995.webp";
import asset588 from "../img/projectImages/9734f3802791d05c72dd.webp";
import asset589 from "../img/projectImages/8aefcae5fe79e1f2ee94.webp";
import asset590 from "../img/projectImages/bf3e3d4bf58ab0d8763c.webp";
import asset591 from "../img/projectImages/5c04d4cf55a117c5976a.webp";
import asset592 from "../img/projectImages/b04a08ac705e3e382491.webp";
import asset593 from "../img/projectImages/1794aad5675ea159bc07.webp";
import asset594 from "../img/projectImages/b5a6cbeea939e99d2fdd.webp";
import asset595 from "../img/projectImages/a49ba53b19620469393f.webp";
import asset596 from "../img/projectImages/e55d91e66232c8f6f9cc.webp";
import asset597 from "../img/projectImages/32076dc971988698997b.webp";
import asset598 from "../img/projectImages/d00afbc34e47cdb8afe4.webp";
import asset599 from "../img/projectImages/fc582cea2c738e3f2fb2.webp";
import asset600 from "../img/projectImages/e6df1d6972367e520a7e.webp";
import asset601 from "../img/projectImages/fa40acb48b90eb769ff7.webp";
import asset602 from "../img/projectImages/f7e157769627e29809b4.webp";
import asset603 from "../img/projectImages/d82d72de6ae9b8802794.webp";
import asset604 from "../img/projectImages/b6c9e4f28a5f57c396ea.webp";
import asset605 from "../img/projectImages/5f7db5c56e6145ded1ef.webp";
import asset606 from "../img/projectImages/1e58a849b51b54389be7.webp";
import asset607 from "../img/projectImages/b0f446019971da26ccb8.webp";
import asset608 from "../img/projectImages/6ae1f05ada324def8d02.webp";
import asset609 from "../img/projectImages/1abf05f0552148fc12b0.webp";
import asset610 from "../img/projectImages/5c49ce72562aab6ba113.webp";
import asset611 from "../img/projectImages/88b1d217408b73399a09.webp";
import asset612 from "../img/projectImages/10296af70dbd5913176d.webp";
import asset613 from "../img/projectImages/69ddbf15459cb0f6d17f.webp";
import asset614 from "../img/projectImages/6cfcc96bc0f58a2949b7.webp";
import asset615 from "../img/projectImages/cea144b58e67e199bff5.webp";
import asset616 from "../img/projectImages/c4731ea3ccf038440957.webp";
import asset617 from "../img/projectImages/1d7b42fe66b4c5f104e9.webp";
import asset618 from "../img/projectImages/3a6ecb9b7ac63fd06cff.webp";
import asset619 from "../img/projectImages/cb0c904dc198de434876.webp";
import asset620 from "../img/projectImages/a9f5b8b867759b9f339f.webp";
import asset621 from "../img/projectImages/769e6c45936ee0ebe75b.webp";
import asset622 from "../img/projectImages/99accfaf4d63df89fd4f.webp";
import asset623 from "../img/projectImages/22087e08dc9f689e02b4.webp";
import asset624 from "../img/projectImages/1b558d7fa919439933f9.webp";
import asset625 from "../img/projectImages/f895922fde305a128ddd.webp";
import asset626 from "../img/projectImages/cc5c0242c238343f0071.webp";
import asset627 from "../img/projectImages/6a364c9979448255665c.webp";
import asset628 from "../img/projectImages/b5909813d405a439ea7b.webp";
import asset629 from "../img/projectImages/53f00bbd419d0145b417.webp";
import asset630 from "../img/projectImages/7fddf91760271e026adb.webp";
import asset631 from "../img/projectImages/43e912319e38efb9f715.webp";
import asset632 from "../img/projectImages/9d465b6d47db51919d78.webp";
import asset633 from "../img/projectImages/85f4f53757730637438c.webp";
import asset634 from "../img/projectImages/249a3d33a28c89735029.webp";
import asset635 from "../img/projectImages/92c6750581fbf73111a5.webp";
import asset636 from "../img/projectImages/5b5d198092891182b8d0.webp";
import asset637 from "../img/projectImages/3f00b60bd7d287bb0b38.webp";
import asset638 from "../img/projectImages/ebcc419542de6d10f23d.webp";
import asset639 from "../img/projectImages/ab4465563fb1506716aa.webp";
import asset640 from "../img/projectImages/54a18ddb532bd1228ad6.webp";
import asset641 from "../img/projectImages/beee45d9cd06803ad52f.webp";
import asset642 from "../img/projectImages/445cc74bb7f1e4b5ef38.webp";
import asset643 from "../img/projectImages/a552a131a0a285dee0a0.webp";
import asset644 from "../img/projectImages/9a6befce039cf27dd5d8.webp";
import asset645 from "../img/projectImages/0607d1130ff9caef8b7d.webp";
import asset646 from "../img/projectImages/0ceb4323cf5b4c39bb95.webp";
import asset647 from "../img/projectImages/10efdae98567e1a65f52.webp";
import asset648 from "../img/projectImages/92f01942526f760698bf.webp";
import asset649 from "../img/projectImages/daeddaa8736b6495b4bc.webp";
import asset650 from "../img/projectImages/7b56162d287ccde76701.webp";
import asset651 from "../img/projectImages/e8947b6f823a7e47ae17.webp";
import asset652 from "../img/projectImages/90fce2b68d24ab082665.webp";
import asset653 from "../img/projectImages/efe5c39a1e8ab11ecb22.webp";
import asset654 from "../img/projectImages/29d6e33af7b3eddb30ae.webp";
import asset655 from "../img/projectImages/af86bf0caed5f77476e4.webp";
import asset656 from "../img/projectImages/b9c2af641bfec25d1881.webp";
import asset657 from "../img/projectImages/998bea42d923624cd547.webp";
import asset658 from "../img/projectImages/1ada3e816fe4dfa4ac23.webp";
import asset659 from "../img/projectImages/709de591d734f592c1ec.webp";
import asset660 from "../img/projectImages/82d388b0694d5a32a71b.webp";
import asset661 from "../img/projectImages/6cebf1698ea4bda85959.webp";
import asset662 from "../img/projectImages/827ba02183fe567d8595.webp";
import asset663 from "../img/projectImages/21f2aa895ba246c2cafb.webp";
import asset664 from "../img/projectImages/462c0a228872731b274d.webp";
import asset665 from "../img/projectImages/80189e51e5d9f656ad63.webp";
import asset666 from "../img/projectImages/96150f9fd0ec4e89d8b4.webp";
import asset667 from "../img/projectImages/bad3b10ccdab10a921ce.webp";
import asset668 from "../img/projectImages/d6dccbec26db4acd66c0.webp";
import asset669 from "../img/projectImages/cd14c667700ac2a10d2c.webp";
import asset670 from "../img/projectImages/fc3c6a12a3a0c4b3e003.webp";
import asset671 from "../img/projectImages/879393f03cd3858e62ab.webp";
import asset672 from "../img/projectImages/73fc1fb43f187e43707f.webp";
import asset673 from "../img/projectImages/8534cbb8573de33660a5.webp";
import asset674 from "../img/projectImages/98654986562110f49022.webp";
import asset675 from "../img/projectImages/74f33b34c8c6d9472411.webp";
import asset676 from "../img/projectImages/44a1fd877c5c5b347d6c.webp";
import asset677 from "../img/projectImages/dd72c3f63c6be308cc88.webp";
import asset678 from "../img/projectImages/0403c85eb53ece033ee0.webp";
import asset679 from "../img/projectImages/650271cfa349837595d0.webp";
import asset680 from "../img/projectImages/02dbcfb45b2c21c699f9.webp";
import asset681 from "../img/projectImages/b6d7b869022aec1da8fd.webp";
import asset682 from "../img/projectImages/8de7cad405fce6b334e4.webp";
import asset683 from "../img/projectImages/f69633b997c2c5167727.webp";
import asset684 from "../img/projectImages/2b2e51ce138b3428ec8c.webp";
import asset685 from "../img/projectImages/a1712691460233985d16.webp";
import asset686 from "../img/projectImages/2c406b35eee7b9d69aa9.webp";
export const referenceCategories = [
  {
    "name": "residential",
    "title": "Residential",
    "titleFa": "مسکونی",
    "cover": asset0
  },
  {
    "name": "healthcare",
    "title": "Healthcare",
    "titleFa": "درمانی",
    "cover": asset144
  },
  {
    "name": "construction",
    "title": "Construction",
    "titleFa": "ساخت",
    "cover": null
  },
  {
    "name": "villa",
    "title": "Villa",
    "titleFa": "ویلا",
    "cover": asset484
  },
  {
    "name": "international",
    "title": "International",
    "titleFa": "بین‌المللی",
    "cover": asset219
  },
  {
    "name": "industrial",
    "title": "Industrial",
    "titleFa": "صنعتی",
    "cover": asset563
  },
  {
    "name": "office",
    "title": "Office",
    "titleFa": "اداری",
    "cover": asset292
  },
  {
    "name": "commercial",
    "title": "Commercial",
    "titleFa": "تجاری",
    "cover": asset327
  },
  {
    "name": "highrize",
    "title": "Highrise",
    "titleFa": "بلندمرتبه",
    "cover": asset11
  },
  {
    "name": "hotel",
    "title": "Hotel",
    "titleFa": "هتل",
    "cover": asset663
  },
  {
    "name": "interior",
    "title": "Interior",
    "titleFa": "طراحی داخلی",
    "cover": asset355
  },
  {
    "name": "restaurant",
    "title": "Cafe & Restaurant",
    "titleFa": "کافه و رستوران",
    "cover": asset673
  },
  {
    "name": "sport",
    "title": "Sport",
    "titleFa": "ورزشی",
    "cover": asset340
  },
  {
    "name": "drywall",
    "title": "Drywall",
    "titleFa": "ساخت خشک",
    "cover": null
  }
];
export const referenceProjects = [
  {
    "category": "residential",
    "projectName": "paradise",
    "label": "آپارتمان مسکونی پارادایز",
    "files": [
      asset1,
      asset2,
      asset3,
      asset4,
      asset5,
      asset6,
      asset7,
      asset8,
      asset9
    ],
    "source": "01-Residental/01 آپارتمان مسکونی پارادایز -",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "olgoo",
    "label": "محله مسکونی الگو",
    "files": [
      asset10,
      asset11,
      asset12,
      asset13,
      asset14,
      asset15,
      asset16,
      asset17,
      asset18,
      asset19,
      asset20,
      asset21,
      asset22
    ],
    "source": "01-Residental/02 محله مسکونی الگو",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "twenty-fifth-residential",
    "label": "آپارتمان مسکونی بیست و پنجم",
    "files": [
      asset0,
      asset23,
      asset24,
      asset25,
      asset26,
      asset27,
      asset28,
      asset29,
      asset30,
      asset31,
      asset32,
      asset33,
      asset34,
      asset35,
      asset36,
      asset37,
      asset38,
      asset39,
      asset40,
      asset41,
      asset42,
      asset43,
      asset44,
      asset45,
      asset46
    ],
    "source": "01-Residental/03 آپارتمان مسکونی بیست و پنجم",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "sarv",
    "label": "مجتمع مسکونی سرو",
    "files": [
      asset47,
      asset48,
      asset49,
      asset50,
      asset51,
      asset52,
      asset53,
      asset54,
      asset55,
      asset56,
      asset57,
      asset58,
      asset59,
      asset60,
      asset61,
      asset62,
      asset63
    ],
    "source": "01-Residental/04- مجتمع مسکونی سرو",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "lutus",
    "label": "ساختمان مسکونی لوتوس",
    "files": [
      asset64,
      asset65,
      asset66,
      asset67,
      asset68,
      asset69,
      asset70
    ],
    "source": "01-Residental/05 - ساختمان مسکونی لوتوس",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "makooeipoor",
    "label": "آپارتمان مسکونی ماکویی پور",
    "files": [
      asset71,
      asset72,
      asset73,
      asset74,
      asset75,
      asset76,
      asset77,
      asset78,
      asset79
    ],
    "source": "01-Residental/06 - آپارتمان مسکونی ماکویی پور",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "mehrdad",
    "label": "آپارتمان مهرداد",
    "files": [
      asset80,
      asset81,
      asset82,
      asset83,
      asset84,
      asset85
    ],
    "source": "01-Residental/07 -آپارتمان مهرداد",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "darbandsar",
    "label": "آپارتمان مسکونی دربندسر",
    "files": [
      asset86,
      asset87,
      asset88,
      asset89,
      asset90,
      asset91,
      asset92,
      asset93,
      asset94,
      asset95,
      asset96
    ],
    "source": "01-Residental/08- آپارتمان مسکونی دربندسر",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "elahiye",
    "label": "آپارتمان مسکونی الهیه",
    "files": [
      asset97,
      asset98,
      asset99,
      asset100,
      asset101
    ],
    "source": "01-Residental/09- آپارتمان مسکونی الهیه",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "niavaran",
    "label": "آپارتمان مسکونی نیاوران",
    "files": [
      asset102,
      asset103,
      asset104,
      asset105,
      asset106,
      asset107,
      asset108,
      asset109,
      asset110,
      asset111,
      asset112,
      asset113
    ],
    "source": "01-Residental/10-آپارتمان مسکونی نیاوران",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "palazzo",
    "label": "ساختمان مسکونی پلازا-pallazo",
    "files": [
      asset114,
      asset115,
      asset116,
      asset117,
      asset118,
      asset119,
      asset120,
      asset121,
      asset122,
      asset123
    ],
    "source": "01-Residental/11  ساختمان مسکونی پلازا-pallazo",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "tagharon",
    "label": "هتل آپارتمان تقارن",
    "files": [
      asset124,
      asset125,
      asset126
    ],
    "source": "01-Residental/12- هتل آپارتمان تقارن",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "eichenhof",
    "label": "HOTEL  EICHENHOF",
    "files": [
      asset127,
      asset128,
      asset129,
      asset130,
      asset131,
      asset132,
      asset133,
      asset134
    ],
    "source": "01-Residental/13  HOTEL  EICHENHOF",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "astara",
    "label": "آپارتمان مسکونی آستارا",
    "files": [
      asset135,
      asset136,
      asset137,
      asset138,
      asset139,
      asset140,
      asset141
    ],
    "source": "01-Residental/14- آپارتمان مسکونی آستارا",
    "explicitCover": true
  },
  {
    "category": "residential",
    "projectName": "modular-house",
    "label": "خانه مدولار",
    "files": [
      asset142,
      asset143
    ],
    "source": "01-Residental/14- خانه مدولار",
    "explicitCover": false
  },
  {
    "category": "healthcare",
    "projectName": "mom",
    "label": "MOM healthcare",
    "files": [
      asset145,
      asset146,
      asset147,
      asset148,
      asset149,
      asset150,
      asset151,
      asset152,
      asset153,
      asset154,
      asset155,
      asset156,
      asset157,
      asset158,
      asset159,
      asset160,
      asset161,
      asset162,
      asset163,
      asset164,
      asset165,
      asset166,
      asset167,
      asset168,
      asset169,
      asset170,
      asset171,
      asset172,
      asset173,
      asset174,
      asset175,
      asset176,
      asset177,
      asset178,
      asset179,
      asset180,
      asset181,
      asset182
    ],
    "source": "02-Healthcare/01 MOM healthcare",
    "explicitCover": true
  },
  {
    "category": "healthcare",
    "projectName": "yon-therapy",
    "label": "IRAN International HEAVY ION THERAPY",
    "files": [
      asset183,
      asset184,
      asset185,
      asset186,
      asset187,
      asset188,
      asset189,
      asset190,
      asset191,
      asset192,
      asset193,
      asset194,
      asset195,
      asset196,
      asset197,
      asset198,
      asset199,
      asset200,
      asset201,
      asset202,
      asset203,
      asset204,
      asset205,
      asset206,
      asset207,
      asset208,
      asset209,
      asset210,
      asset211,
      asset212,
      asset213,
      asset214,
      asset215,
      asset216
    ],
    "source": "02-Healthcare/02 IRAN International HEAVY ION THERAPY",
    "explicitCover": true
  },
  {
    "category": "healthcare",
    "projectName": "omid-nikan",
    "label": "Omid nikan minor procedure center",
    "files": [
      asset217,
      asset218
    ],
    "source": "02-Healthcare/03 Omid nikan minor procedure center",
    "explicitCover": false
  },
  {
    "category": "healthcare",
    "projectName": "TYULIFE",
    "label": "Tyulife longevity center",
    "files": [
      asset219,
      asset220,
      asset221,
      asset222,
      asset223,
      asset224,
      asset225,
      asset226,
      asset227,
      asset228,
      asset229,
      asset230,
      asset231
    ],
    "source": "02-Healthcare/04 Tyulife longevity center",
    "explicitCover": true
  },
  {
    "category": "healthcare",
    "projectName": "b-brun",
    "label": "B Braun dialysis center",
    "files": [
      asset232,
      asset233,
      asset234,
      asset235
    ],
    "source": "02-Healthcare/05 B Braun dialysis center",
    "explicitCover": true
  },
  {
    "category": "healthcare",
    "projectName": "sartomax-cleanroom",
    "label": "Sartomax cleanroom",
    "files": [
      asset236,
      asset237,
      asset238,
      asset239,
      asset240,
      asset241,
      asset242,
      asset243,
      asset244,
      asset245,
      asset246,
      asset247
    ],
    "source": "02-Healthcare/06 Sartomax cleanroom",
    "explicitCover": true
  },
  {
    "category": "healthcare",
    "projectName": "parsian-saadat-abad",
    "label": "بیمارستان پارسیان",
    "files": [
      asset248,
      asset249,
      asset250,
      asset251,
      asset252
    ],
    "source": "02-Healthcare/06 بیمارستان پارسیان",
    "explicitCover": false
  },
  {
    "category": "healthcare",
    "projectName": "chamran",
    "label": "Chamran hospital",
    "files": [
      asset253,
      asset254,
      asset255,
      asset256,
      asset257,
      asset258,
      asset259,
      asset260,
      asset261,
      asset262
    ],
    "source": "02-Healthcare/07 Chamran hospital",
    "explicitCover": true
  },
  {
    "category": "healthcare",
    "projectName": "haft-e-tir",
    "label": "Haft-e TIR HOSPITAL",
    "files": [
      asset263
    ],
    "source": "02-Healthcare/08 Haft-e TIR HOSPITAL",
    "explicitCover": false
  },
  {
    "category": "construction",
    "projectName": "arta",
    "label": "arta",
    "files": [
      asset264,
      asset265,
      asset266,
      asset267,
      asset268,
      asset269,
      asset270,
      asset271,
      asset272,
      asset273,
      asset274,
      asset275,
      asset276,
      asset277,
      asset278,
      asset279,
      asset280,
      asset281,
      asset282,
      asset283,
      asset284,
      asset285,
      asset286,
      asset287,
      asset288
    ],
    "source": "03-construction/001- arta",
    "explicitCover": false
  },
  {
    "category": "construction",
    "projectName": "hafez",
    "label": "ساختمان اداری-تجاری حافظ",
    "files": [
      asset289,
      asset290,
      asset291,
      asset292,
      asset293,
      asset294,
      asset295,
      asset296,
      asset297,
      asset298,
      asset299,
      asset300,
      asset301,
      asset302,
      asset303,
      asset304,
      asset305,
      asset306,
      asset307,
      asset308,
      asset309,
      asset310,
      asset311,
      asset312,
      asset313,
      asset314,
      asset315,
      asset316,
      asset317,
      asset318,
      asset319,
      asset320,
      asset321
    ],
    "source": "03-construction/002- ساختمان اداری-تجاری حافظ",
    "explicitCover": false
  },
  {
    "category": "construction",
    "projectName": "mom",
    "label": "MOM healthcare",
    "files": [
      asset145,
      asset146,
      asset147,
      asset148,
      asset149,
      asset150,
      asset151,
      asset152,
      asset153,
      asset154,
      asset155,
      asset156,
      asset157,
      asset158,
      asset159,
      asset160,
      asset161,
      asset162,
      asset163,
      asset164,
      asset165,
      asset166,
      asset167,
      asset168,
      asset169,
      asset170,
      asset171,
      asset172,
      asset173,
      asset174,
      asset175,
      asset176,
      asset177,
      asset178,
      asset179,
      asset180,
      asset181,
      asset182
    ],
    "source": "03-construction/003 MOM healthcare",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "refah",
    "label": "ساختمان فروشگاه رفاه",
    "files": [
      asset322,
      asset323,
      asset324,
      asset325,
      asset326,
      asset327,
      asset328,
      asset329,
      asset330,
      asset331,
      asset332
    ],
    "source": "03-construction/004- ساختمان فروشگاه رفاه",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "roshd",
    "label": "مجتمع ورزشی رشد",
    "files": [
      asset333,
      asset334,
      asset335,
      asset336,
      asset337,
      asset338,
      asset339,
      asset340,
      asset341,
      asset342,
      asset343,
      asset344,
      asset345,
      asset346,
      asset347,
      asset348,
      asset349,
      asset350,
      asset351,
      asset352,
      asset353,
      asset354
    ],
    "source": "03-construction/005- مجتمع ورزشی رشد",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "lutus",
    "label": "ساختمان مسکونی لوتوس",
    "files": [
      asset64,
      asset65,
      asset66,
      asset67,
      asset68,
      asset69,
      asset70
    ],
    "source": "03-construction/006 - ساختمان مسکونی لوتوس",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "twenty-fifth-residential",
    "label": "آپارتمان مسکونی بیست و پنجم",
    "files": [
      asset0,
      asset23,
      asset24,
      asset25,
      asset26,
      asset27,
      asset28,
      asset29,
      asset30,
      asset31,
      asset32,
      asset33,
      asset34,
      asset35,
      asset36,
      asset37,
      asset38,
      asset39,
      asset40,
      asset41,
      asset42,
      asset43,
      asset44,
      asset45,
      asset46
    ],
    "source": "03-construction/007 آپارتمان مسکونی بیست و پنجم",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "stg",
    "label": "STG-شرکت صحرا تجارت قره قول",
    "files": [
      asset355,
      asset356,
      asset357,
      asset358,
      asset359,
      asset360,
      asset361,
      asset362,
      asset363,
      asset364,
      asset365,
      asset366,
      asset367,
      asset368,
      asset369
    ],
    "source": "03-construction/008 - STG-شرکت صحرا تجارت قره قول",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "sarv",
    "label": "مجتمع مسکونی سرو",
    "files": [
      asset47,
      asset48,
      asset49,
      asset50,
      asset51,
      asset52,
      asset53,
      asset54,
      asset55,
      asset56,
      asset57,
      asset58,
      asset59,
      asset60,
      asset61,
      asset62,
      asset63
    ],
    "source": "03-construction/009- مجتمع مسکونی سرو",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "pharmed-plast",
    "label": "pharmed past- کارخانه فارمد پلاست",
    "files": [
      asset370
    ],
    "source": "03-construction/010- pharmed past- کارخانه فارمد پلاست",
    "explicitCover": false
  },
  {
    "category": "construction",
    "projectName": "ylg",
    "label": "YLG Yazdani Law Group-شرکت حقوقی بین المللی گروه وکالتی یزدانی",
    "files": [
      asset371,
      asset372,
      asset373,
      asset374,
      asset375,
      asset376,
      asset377,
      asset378,
      asset379,
      asset380,
      asset381,
      asset382
    ],
    "source": "03-construction/011 -YLG Yazdani Law Group-شرکت حقوقی بین المللی گروه وکالتی یزدانی",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "melli-exchange",
    "label": "صرافی ملی ایران",
    "files": [
      asset383,
      asset384,
      asset385,
      asset386
    ],
    "source": "03-construction/012- صرافی ملی ایران",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "mehr-o-mah",
    "label": "مهر و ماه",
    "files": [
      asset387,
      asset388,
      asset389,
      asset390,
      asset391,
      asset392,
      asset393,
      asset394,
      asset395,
      asset396,
      asset397,
      asset398,
      asset399,
      asset400,
      asset401
    ],
    "source": "03-construction/013- مهر و ماه",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "mahtab",
    "label": "مهتاب",
    "files": [
      asset402,
      asset403,
      asset404,
      asset405,
      asset406,
      asset407,
      asset408,
      asset409,
      asset410,
      asset411,
      asset412,
      asset413,
      asset414,
      asset415
    ],
    "source": "03-construction/014- مهتاب",
    "explicitCover": false
  },
  {
    "category": "construction",
    "projectName": "baghe-gerdoo",
    "label": "ویلای باغ گردو",
    "files": [
      asset416,
      asset417,
      asset418,
      asset419,
      asset420,
      asset421,
      asset422,
      asset423,
      asset424,
      asset425,
      asset426,
      asset427,
      asset428,
      asset429,
      asset430,
      asset431,
      asset432,
      asset433
    ],
    "source": "03-construction/015-ویلای باغ گردو",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "kordeVilla",
    "label": "kordevilla",
    "files": [
      asset434,
      asset435,
      asset436,
      asset437,
      asset438,
      asset439,
      asset440,
      asset441,
      asset442,
      asset443,
      asset444,
      asset445,
      asset446,
      asset447
    ],
    "source": "03-construction/016 - kordevilla",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "makooeipoor",
    "label": "آپارتمان مسکونی ماکویی پور",
    "files": [
      asset71,
      asset72,
      asset73,
      asset74,
      asset75,
      asset76,
      asset77,
      asset78,
      asset79
    ],
    "source": "03-construction/017 - آپارتمان مسکونی ماکویی پور",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "ana",
    "label": "ana",
    "files": [
      asset448,
      asset449,
      asset450,
      asset451,
      asset452,
      asset453,
      asset454,
      asset455,
      asset456,
      asset457
    ],
    "source": "03-construction/018- ana",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "mehrdad",
    "label": "آپارتمان مهرداد",
    "files": [
      asset80,
      asset81,
      asset82,
      asset83,
      asset84,
      asset85
    ],
    "source": "03-construction/019 -آپارتمان مهرداد",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "golestani-shop",
    "label": "گالری گلستانی",
    "files": [
      asset458,
      asset459
    ],
    "source": "03-construction/020- گالری گلستانی",
    "explicitCover": false
  },
  {
    "category": "construction",
    "projectName": "khazarshahr",
    "label": "خزرشهر",
    "files": [
      asset460,
      asset461,
      asset462,
      asset463,
      asset464,
      asset465,
      asset466,
      asset467,
      asset468,
      asset469,
      asset470,
      asset471,
      asset472
    ],
    "source": "03-construction/021- خزرشهر",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "ansaldo",
    "label": "دفتر شرکت آنسالدو",
    "files": [
      asset473,
      asset474,
      asset475,
      asset476,
      asset477,
      asset478,
      asset479,
      asset480
    ],
    "source": "03-construction/022-دفتر شرکت آنسالدو",
    "explicitCover": true
  },
  {
    "category": "construction",
    "projectName": "nova-pharmed",
    "label": "نوافارمد  009 -NOVA Pharmed",
    "files": [
      asset481,
      asset482,
      asset483
    ],
    "source": "03-construction/نوافارمد  009 -NOVA Pharmed",
    "explicitCover": false
  },
  {
    "category": "villa",
    "projectName": "khaneBala",
    "label": "khane bala",
    "files": [
      asset485,
      asset486,
      asset484,
      asset487,
      asset488,
      asset489,
      asset490,
      asset491,
      asset492,
      asset493
    ],
    "source": "04-Villa/01- khane bala",
    "explicitCover": true
  },
  {
    "category": "villa",
    "projectName": "arta",
    "label": "arta",
    "files": [
      asset264,
      asset265,
      asset266,
      asset267,
      asset268,
      asset269,
      asset270,
      asset271,
      asset272,
      asset273,
      asset274,
      asset275,
      asset276,
      asset277,
      asset278,
      asset279,
      asset280,
      asset281,
      asset282,
      asset283,
      asset284,
      asset285,
      asset286,
      asset287,
      asset288
    ],
    "source": "04-Villa/02- arta",
    "explicitCover": false
  },
  {
    "category": "villa",
    "projectName": "ana",
    "label": "ana",
    "files": [
      asset448,
      asset449,
      asset450,
      asset451,
      asset452,
      asset453,
      asset454,
      asset455,
      asset456,
      asset457
    ],
    "source": "04-Villa/03- ana",
    "explicitCover": true
  },
  {
    "category": "villa",
    "projectName": "khanjan",
    "label": "ویلای خان جان",
    "files": [
      asset494,
      asset495,
      asset496,
      asset497,
      asset498,
      asset499,
      asset500
    ],
    "source": "04-Villa/04-  ویلای خان جان",
    "explicitCover": true
  },
  {
    "category": "villa",
    "projectName": "alamoot",
    "label": "ویلای الموت- alamot",
    "files": [
      asset501,
      asset502,
      asset503,
      asset504,
      asset505,
      asset506
    ],
    "source": "04-Villa/05-ویلای الموت- alamot",
    "explicitCover": true
  },
  {
    "category": "villa",
    "projectName": "kordeVilla",
    "label": "kordevilla",
    "files": [
      asset434,
      asset435,
      asset436,
      asset437,
      asset438,
      asset439,
      asset440,
      asset441,
      asset442,
      asset443,
      asset444,
      asset445,
      asset446,
      asset447
    ],
    "source": "04-Villa/06 - kordevilla",
    "explicitCover": true
  },
  {
    "category": "villa",
    "projectName": "baghe-gerdoo",
    "label": "ویلای باغ گردو",
    "files": [
      asset416,
      asset417,
      asset418,
      asset419,
      asset420,
      asset421,
      asset422,
      asset423,
      asset424,
      asset425,
      asset426,
      asset427,
      asset428,
      asset429,
      asset430,
      asset431,
      asset432,
      asset433
    ],
    "source": "04-Villa/07-ویلای باغ گردو",
    "explicitCover": true
  },
  {
    "category": "villa",
    "projectName": "khazarshahr",
    "label": "خزرشهر",
    "files": [
      asset460,
      asset461,
      asset462,
      asset463,
      asset464,
      asset465,
      asset466,
      asset467,
      asset468,
      asset469,
      asset470,
      asset471,
      asset472
    ],
    "source": "04-Villa/08- خزرشهر",
    "explicitCover": true
  },
  {
    "category": "villa",
    "projectName": "aram",
    "label": "ویلای آرام",
    "files": [
      asset507,
      asset508,
      asset509,
      asset510,
      asset511,
      asset512,
      asset513,
      asset514
    ],
    "source": "04-Villa/09-ویلای آرام",
    "explicitCover": true
  },
  {
    "category": "villa",
    "projectName": "gorji-garden",
    "label": "باغ گرجی-10  -gorji garden",
    "files": [
      asset515,
      asset516,
      asset517,
      asset518,
      asset519,
      asset520,
      asset521,
      asset522,
      asset523,
      asset524,
      asset525,
      asset526
    ],
    "source": "04-Villa/باغ گرجی-10  -gorji garden",
    "explicitCover": false
  },
  {
    "category": "international",
    "projectName": "TYULIFE",
    "label": "tyulife",
    "files": [
      asset219,
      asset220,
      asset221,
      asset222,
      asset223,
      asset224,
      asset225,
      asset226,
      asset227,
      asset228,
      asset229,
      asset230,
      asset231
    ],
    "source": "05-International/01 tyulife",
    "explicitCover": true
  },
  {
    "category": "international",
    "projectName": "mom",
    "label": "mom",
    "files": [
      asset145,
      asset146,
      asset147,
      asset148,
      asset149,
      asset150,
      asset151,
      asset152,
      asset153,
      asset154,
      asset155,
      asset156,
      asset157,
      asset158,
      asset159,
      asset160,
      asset161,
      asset162,
      asset163,
      asset164,
      asset165,
      asset166,
      asset167,
      asset168,
      asset169,
      asset170,
      asset171,
      asset172,
      asset173,
      asset174,
      asset175,
      asset176,
      asset177,
      asset178,
      asset179,
      asset180,
      asset181,
      asset182
    ],
    "source": "05-International/02 mom",
    "explicitCover": true
  },
  {
    "category": "international",
    "projectName": "eichenhof",
    "label": "HOTEL  EICHENHOF",
    "files": [
      asset127,
      asset128,
      asset129,
      asset130,
      asset131,
      asset132,
      asset133,
      asset134
    ],
    "source": "05-International/03  HOTEL  EICHENHOF",
    "explicitCover": true
  },
  {
    "category": "international",
    "projectName": "cafe-bakery-dubai",
    "label": "cafe bakery , dubai",
    "files": [
      asset527,
      asset528,
      asset529,
      asset530,
      asset531,
      asset532,
      asset533,
      asset534,
      asset535,
      asset536,
      asset537,
      asset538,
      asset539,
      asset540,
      asset541,
      asset542,
      asset543,
      asset544,
      asset545
    ],
    "source": "05-International/04-  cafe bakery , dubai",
    "explicitCover": true
  },
  {
    "category": "international",
    "projectName": "sartomax-cleanroom",
    "label": "sartomax",
    "files": [
      asset236,
      asset237,
      asset238,
      asset239,
      asset240,
      asset241,
      asset242,
      asset243,
      asset244,
      asset245,
      asset246,
      asset247
    ],
    "source": "05-International/05 sartomax",
    "explicitCover": true
  },
  {
    "category": "international",
    "projectName": "OBP",
    "label": "obp",
    "files": [
      asset546,
      asset547,
      asset548,
      asset549,
      asset550,
      asset551,
      asset552,
      asset553,
      asset554,
      asset555,
      asset556,
      asset557,
      asset558,
      asset559,
      asset560,
      asset561,
      asset562
    ],
    "source": "05-International/07- obp",
    "explicitCover": true
  },
  {
    "category": "industrial",
    "projectName": "lavin",
    "label": "کارخانه رب گوجه فرنگی لاوین",
    "files": [
      asset563,
      asset564,
      asset565,
      asset566,
      asset567,
      asset568,
      asset569,
      asset570,
      asset571,
      asset572,
      asset573,
      asset574,
      asset575,
      asset576,
      asset577,
      asset578
    ],
    "source": "06-Industrial/01- کارخانه رب گوجه فرنگی لاوین",
    "explicitCover": true
  },
  {
    "category": "industrial",
    "projectName": "medway",
    "label": "کارخانه مدوی- Medway",
    "files": [
      asset579,
      asset580,
      asset581,
      asset582,
      asset583,
      asset584,
      asset585,
      asset586,
      asset587,
      asset588,
      asset589,
      asset590,
      asset591,
      asset592,
      asset593,
      asset594,
      asset595,
      asset596,
      asset597,
      asset598
    ],
    "source": "06-Industrial/02- کارخانه مدوی- Medway",
    "explicitCover": true
  },
  {
    "category": "industrial",
    "projectName": "pharmed-plast",
    "label": "pharmed past- کارخانه فارمد پلاست",
    "files": [
      asset370
    ],
    "source": "06-Industrial/03- pharmed past- کارخانه فارمد پلاست",
    "explicitCover": false
  },
  {
    "category": "industrial",
    "projectName": "farachap",
    "label": "کارخانه فراچاپ",
    "files": [
      asset599,
      asset600,
      asset601,
      asset602,
      asset603,
      asset604,
      asset605,
      asset606,
      asset607
    ],
    "source": "06-Industrial/05- کارخانه فراچاپ",
    "explicitCover": false
  },
  {
    "category": "industrial",
    "projectName": "nova-pharmed",
    "label": "نوافارمد  04 -NOVA Pharmed",
    "files": [
      asset481,
      asset482,
      asset483
    ],
    "source": "06-Industrial/نوافارمد  04 -NOVA Pharmed",
    "explicitCover": false
  },
  {
    "category": "office",
    "projectName": "hafez",
    "label": "ساختمان اداری-تجاری حافظ",
    "files": [
      asset289,
      asset290,
      asset291,
      asset292,
      asset293,
      asset294,
      asset295,
      asset296,
      asset297,
      asset298,
      asset299,
      asset300,
      asset301,
      asset302,
      asset303,
      asset304,
      asset305,
      asset306,
      asset307,
      asset308,
      asset309,
      asset310,
      asset311,
      asset312,
      asset313,
      asset314,
      asset315,
      asset316,
      asset317,
      asset318,
      asset319,
      asset320,
      asset321
    ],
    "source": "07-Office/01- ساختمان اداری-تجاری حافظ",
    "explicitCover": false
  },
  {
    "category": "office",
    "projectName": "stg",
    "label": "STG-شرکت صحرا تجارت قره قول",
    "files": [
      asset355,
      asset356,
      asset357,
      asset358,
      asset359,
      asset360,
      asset361,
      asset362,
      asset363,
      asset364,
      asset365,
      asset366,
      asset367,
      asset368,
      asset369
    ],
    "source": "07-Office/02 - STG-شرکت صحرا تجارت قره قول",
    "explicitCover": true
  },
  {
    "category": "office",
    "projectName": "ylg",
    "label": "YLG Yazdani Law Group-شرکت حقوقی بین المللی گروه وکالتی یزدانی",
    "files": [
      asset371,
      asset372,
      asset373,
      asset374,
      asset375,
      asset376,
      asset377,
      asset378,
      asset379,
      asset380,
      asset381,
      asset382
    ],
    "source": "07-Office/03 -YLG Yazdani Law Group-شرکت حقوقی بین المللی گروه وکالتی یزدانی",
    "explicitCover": true
  },
  {
    "category": "office",
    "projectName": "ghareghol",
    "label": "ساختمان اداری-تجاری قره قول",
    "files": [
      asset608,
      asset609,
      asset610,
      asset611
    ],
    "source": "07-Office/04- ساختمان اداری-تجاری قره قول",
    "explicitCover": false
  },
  {
    "category": "office",
    "projectName": "holding-gandi",
    "label": "ساختمان اداری گاندی",
    "files": [
      asset612,
      asset613,
      asset614,
      asset615,
      asset616,
      asset617,
      asset618,
      asset619,
      asset620,
      asset621,
      asset622,
      asset623,
      asset624,
      asset625,
      asset626,
      asset627,
      asset628
    ],
    "source": "07-Office/05- ساختمان اداری گاندی",
    "explicitCover": true
  },
  {
    "category": "office",
    "projectName": "ansaldo",
    "label": "دفتر شرکت آنسالدو",
    "files": [
      asset473,
      asset474,
      asset475,
      asset476,
      asset477,
      asset478,
      asset479,
      asset480
    ],
    "source": "07-Office/06-دفتر شرکت آنسالدو",
    "explicitCover": true
  },
  {
    "category": "office",
    "projectName": "OBP",
    "label": "obp",
    "files": [
      asset546,
      asset547,
      asset548,
      asset549,
      asset550,
      asset551,
      asset552,
      asset553,
      asset554,
      asset555,
      asset556,
      asset557,
      asset558,
      asset559,
      asset560,
      asset561,
      asset562
    ],
    "source": "07-Office/07- obp",
    "explicitCover": true
  },
  {
    "category": "office",
    "projectName": "sartomax",
    "label": "SARTOMAX",
    "files": [
      asset236,
      asset238,
      asset629,
      asset630,
      asset631,
      asset632,
      asset245,
      asset246,
      asset633,
      asset247
    ],
    "source": "07-Office/08- SARTOMAX",
    "explicitCover": true
  },
  {
    "category": "office",
    "projectName": "farachap",
    "label": "کارخانه فراچاپ",
    "files": [
      asset599,
      asset600,
      asset601,
      asset602,
      asset603,
      asset604,
      asset605,
      asset606,
      asset607
    ],
    "source": "07-Office/09- کارخانه فراچاپ",
    "explicitCover": false
  },
  {
    "category": "office",
    "projectName": "ODCC",
    "label": "ODCC-شرکت طراحی و ساختمان نفت",
    "files": [
      asset634,
      asset635,
      asset636,
      asset637,
      asset638,
      asset639,
      asset640,
      asset641,
      asset642,
      asset643
    ],
    "source": "07-Office/10- ODCC-شرکت طراحی و ساختمان نفت",
    "explicitCover": true
  },
  {
    "category": "commercial",
    "projectName": "refah",
    "label": "ساختمان فروشگاه رفاه",
    "files": [
      asset322,
      asset323,
      asset324,
      asset325,
      asset326,
      asset327,
      asset328,
      asset329,
      asset330,
      asset331,
      asset332
    ],
    "source": "08-Commercial/01- ساختمان فروشگاه رفاه",
    "explicitCover": true
  },
  {
    "category": "commercial",
    "projectName": "ghareghol",
    "label": "ساختمان اداری-تجاری قره قول",
    "files": [
      asset608,
      asset609,
      asset610,
      asset611
    ],
    "source": "08-Commercial/02- ساختمان اداری-تجاری قره قول",
    "explicitCover": false
  },
  {
    "category": "commercial",
    "projectName": "melli-exchange",
    "label": "صرافی ملی ایران",
    "files": [
      asset383,
      asset384,
      asset385,
      asset386
    ],
    "source": "08-Commercial/03- صرافی ملی ایران",
    "explicitCover": true
  },
  {
    "category": "commercial",
    "projectName": "ana-hall",
    "label": "Ana hall -تالار آنا",
    "files": [
      asset644,
      asset645,
      asset646,
      asset647,
      asset648,
      asset649,
      asset650,
      asset651
    ],
    "source": "08-Commercial/04-Ana hall -تالار آنا",
    "explicitCover": true
  },
  {
    "category": "commercial",
    "projectName": "nikan-exchange",
    "label": "صرافی نیکان",
    "files": [
      asset652,
      asset653,
      asset654,
      asset655,
      asset656
    ],
    "source": "08-Commercial/05-صرافی نیکان",
    "explicitCover": true
  },
  {
    "category": "commercial",
    "projectName": "golestani-shop",
    "label": "گالری گلستانی",
    "files": [
      asset458,
      asset459
    ],
    "source": "08-Commercial/06- گالری گلستانی",
    "explicitCover": false
  },
  {
    "category": "highrize",
    "projectName": "olgoo",
    "label": "محله مسکونی الگو",
    "files": [
      asset10,
      asset11,
      asset12,
      asset13,
      asset14,
      asset15,
      asset16,
      asset17,
      asset18,
      asset19,
      asset20,
      asset21,
      asset22
    ],
    "source": "09-Highrise/01 محله مسکونی الگو",
    "explicitCover": true
  },
  {
    "category": "highrize",
    "projectName": "did-hotel",
    "label": "هتل دید",
    "files": [
      asset657,
      asset658,
      asset659,
      asset660,
      asset661
    ],
    "source": "09-Highrise/02- هتل دید",
    "explicitCover": true
  },
  {
    "category": "highrize",
    "projectName": "moj-hotel",
    "label": "هتل موج",
    "files": [
      asset662
    ],
    "source": "09-Highrise/03- هتل موج",
    "explicitCover": false
  },
  {
    "category": "hotel",
    "projectName": "tagharon",
    "label": "هتل آپارتمان تقارن",
    "files": [
      asset124,
      asset125,
      asset126
    ],
    "source": "10-Hotel/01- هتل آپارتمان تقارن",
    "explicitCover": true
  },
  {
    "category": "hotel",
    "projectName": "eichenhof",
    "label": "HOTEL  EICHENHOF",
    "files": [
      asset127,
      asset128,
      asset129,
      asset130,
      asset131,
      asset132,
      asset133,
      asset134
    ],
    "source": "10-Hotel/02- HOTEL  EICHENHOF",
    "explicitCover": true
  },
  {
    "category": "hotel",
    "projectName": "did-hotel",
    "label": "هتل دید",
    "files": [
      asset657,
      asset658,
      asset659,
      asset660,
      asset661
    ],
    "source": "10-Hotel/03- هتل دید",
    "explicitCover": true
  },
  {
    "category": "hotel",
    "projectName": "moj-hotel",
    "label": "هتل موج",
    "files": [
      asset662
    ],
    "source": "10-Hotel/04- هتل موج",
    "explicitCover": false
  },
  {
    "category": "interior",
    "projectName": "twenty-fifth-residential",
    "label": "آپارتمان مسکونی بیست و پنجم",
    "files": [
      asset664,
      asset665,
      asset666,
      asset667,
      asset668,
      asset669,
      asset670,
      asset671
    ],
    "source": "11-Interior/01 آپارتمان مسکونی بیست و پنجم",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "stg",
    "label": "STG-شرکت صحرا تجارت قره قول",
    "files": [
      asset355,
      asset356,
      asset357,
      asset358,
      asset359,
      asset360,
      asset361,
      asset362,
      asset363,
      asset364,
      asset365,
      asset366,
      asset367,
      asset368,
      asset369
    ],
    "source": "11-Interior/02 - STG-شرکت صحرا تجارت قره قول",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "ylg",
    "label": "YLG Yazdani Law Group-شرکت حقوقی بین المللی گروه وکالتی یزدانی",
    "files": [
      asset371,
      asset372,
      asset373,
      asset374,
      asset375,
      asset376,
      asset377,
      asset378,
      asset379,
      asset380,
      asset381,
      asset382
    ],
    "source": "11-Interior/03 -YLG Yazdani Law Group-شرکت حقوقی بین المللی گروه وکالتی یزدانی",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "sarv",
    "label": "مجتمع مسکونی سرو",
    "files": [
      asset48,
      asset51,
      asset50,
      asset49,
      asset56,
      asset672
    ],
    "source": "11-Interior/04  مجتمع مسکونی سرو",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "makooeipoor",
    "label": "آپارتمان مسکونی ماکویی پور",
    "files": [
      asset71,
      asset72,
      asset73,
      asset74,
      asset75,
      asset76,
      asset77,
      asset78,
      asset79
    ],
    "source": "11-Interior/05 - آپارتمان مسکونی ماکویی پور",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "darbandsar",
    "label": "آپارتمان مسکونی دربندسر",
    "files": [
      asset86,
      asset87,
      asset88,
      asset89,
      asset90,
      asset91,
      asset92,
      asset93,
      asset94,
      asset95,
      asset96
    ],
    "source": "11-Interior/06- آپارتمان مسکونی دربندسر",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "OBP",
    "label": "obp",
    "files": [
      asset546,
      asset547,
      asset548,
      asset549,
      asset550,
      asset551,
      asset552,
      asset553,
      asset554,
      asset555,
      asset556,
      asset557,
      asset558,
      asset559,
      asset560,
      asset561,
      asset562
    ],
    "source": "11-Interior/07- obp",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "sartomax",
    "label": "SARTOMAX",
    "files": [
      asset236,
      asset238,
      asset629,
      asset630,
      asset631,
      asset632,
      asset245,
      asset246,
      asset633,
      asset247
    ],
    "source": "11-Interior/08- SARTOMAX",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "mehrdad",
    "label": "آپارتمان مسکونی مهرداد",
    "files": [
      asset80,
      asset81,
      asset82,
      asset83,
      asset84,
      asset85
    ],
    "source": "11-Interior/09 -آپارتمان مسکونی مهرداد",
    "explicitCover": true
  },
  {
    "category": "interior",
    "projectName": "astara",
    "label": "آپارتمان مسکونی آستارا",
    "files": [
      asset135,
      asset136,
      asset137,
      asset138,
      asset139,
      asset140,
      asset141
    ],
    "source": "11-Interior/10- آپارتمان مسکونی آستارا",
    "explicitCover": true
  },
  {
    "category": "restaurant",
    "projectName": "undersea",
    "label": "Undersea,",
    "files": [
      asset674,
      asset673,
      asset675,
      asset676,
      asset677,
      asset678,
      asset679,
      asset680,
      asset681,
      asset682,
      asset683,
      asset684,
      asset685,
      asset686
    ],
    "source": "12-Cafe & restaurant/01-Undersea,",
    "explicitCover": true
  },
  {
    "category": "restaurant",
    "projectName": "cafe-bakery-dubai",
    "label": "cafe bakery , dubai",
    "files": [
      asset527,
      asset528,
      asset529,
      asset530,
      asset531,
      asset532,
      asset533,
      asset534,
      asset535,
      asset536,
      asset537,
      asset538,
      asset539,
      asset540,
      asset541,
      asset542,
      asset543,
      asset544,
      asset545
    ],
    "source": "12-Cafe & restaurant/02-  cafe bakery , dubai",
    "explicitCover": true
  },
  {
    "category": "restaurant",
    "projectName": "mehr-o-mah",
    "label": "مهر و ماه",
    "files": [
      asset387,
      asset388,
      asset389,
      asset390,
      asset391,
      asset392,
      asset393,
      asset394,
      asset395,
      asset396,
      asset397,
      asset398,
      asset399,
      asset400,
      asset401
    ],
    "source": "12-Cafe & restaurant/03- مهر و ماه",
    "explicitCover": true
  },
  {
    "category": "restaurant",
    "projectName": "mahtab",
    "label": "مهتاب",
    "files": [
      asset402,
      asset403,
      asset404,
      asset405,
      asset406,
      asset407,
      asset408,
      asset409,
      asset410,
      asset411,
      asset412,
      asset413,
      asset414,
      asset415
    ],
    "source": "12-Cafe & restaurant/04- مهتاب",
    "explicitCover": false
  },
  {
    "category": "sport",
    "projectName": "roshd",
    "label": "مجتمع ورزشی رشد",
    "files": [
      asset333,
      asset334,
      asset335,
      asset336,
      asset337,
      asset338,
      asset339,
      asset340,
      asset341,
      asset342,
      asset343,
      asset344,
      asset345,
      asset346,
      asset347,
      asset348,
      asset349,
      asset350,
      asset351,
      asset352,
      asset353,
      asset354
    ],
    "source": "13-sport/01- مجتمع ورزشی رشد",
    "explicitCover": true
  }
];
